// extracted by mini-css-extract-plugin
export default {"pokedex":"Pokedex_pokedex__kvtap","pokedex__container":"Pokedex_pokedex__container__WW1RU","pokedex__card":"Pokedex_pokedex__card__amWgX"};